
!(function(){
    const $toString = Function.prototype.toString;
    const symbol = Symbol();
    const myToString = function (){
        return typeof this === 'function' && this[symbol] || $toString.call(this);
    }
    function safeFunction(func, key, value){
        Object.defineProperty(func, key, {
            enumerable: false,
            configurable: true,
            writable: true,
            value: value,
        })
    };
    delete Function.prototype.toString;
    safeFunction(Function.prototype, "toString", myToString);
    safeFunction(Function.prototype.toString, symbol, 'function toString() { [native code] }');
    globalThis.safeFunction = function(func, funcname){
        safeFunction(func, symbol, `function ${funcname || func.name || ''}() { [native code] }`);
    }
})();

function makeFunction(name) {
    // 动态创建一个函数
    var func = new Function(`
        return function ${name}() {
        }
    `)();

    safeFunction(func)

    return func;
}

function Window(){}

// 兼容 Node.js 和浏览器环境，统一挂载到 globalThis
if (typeof globalThis.window === 'undefined') {
    globalThis.window = (typeof global !== 'undefined') ? global : globalThis;
}
safeFunction(globalThis.window)
globalThis.self = globalThis.window;
globalThis.top = globalThis.window;
globalThis.outerWidth = 1536
globalThis.innerWidth = 1528
globalThis.outerHeight = 816
globalThis.innerHeight = 118
globalThis.name = ""

globalThis.window.addEventListener = function (tagName){}
globalThis.MouseEvent = function (tagName){}
globalThis.TouchEvent = function (tagName){}

Object.setPrototypeOf(globalThis.window, Window.prototype)
safeFunction(globalThis.window, 'Window')

globalThis.XMLHttpRequest = function XMLHttpRequest(){};
globalThis.XMLHttpRequest.prototype.open = function (method, url, async){}

globalThis.Ιnfinity = function (tagName){}
globalThis.Ιnk = function (tagName){}
globalThis.DeviceOrientationEvent = function (tagName){}
globalThis.chrome = {
    "app": {
        "isInstalled": false,
        "InstallState": {
            "DISABLED": "disabled",
            "INSTALLED": "installed",
            "NOT_INSTALLED": "not_installed"
        },
        "RunningState": {
            "CANNOT_RUN": "cannot_run",
            "READY_TO_RUN": "ready_to_run",
            "RUNNING": "running"
        }
    }
}
globalThis.HTMLElement = function (tagName){}
globalThis.StyleMedia = undefined
globalThis.DeviceMotionEvent = function (tagName){}
globalThis.loadts = new Date().toString()
globalThis.xsecappid = 'ugc'

Object.setPrototypeOf(globalThis, Window.prototype)
safeFunction(globalThis, 'Window')


function EventTarget() {}
EventTarget.prototype.addEventListener = function (tagName){};
EventTarget.prototype.constructor = EventTarget;
safeFunction(EventTarget.prototype.addEventListener)


function Node(){}
Node.prototype.constructor = Node;
Node.prototype = Object.create(EventTarget.prototype);


function Element(){}safeFunction(Element)
Element.prototype.getAttribute = function getAttribute(){};safeFunction(Element.prototype.getAttribute)
Element.prototype.removeChild = function removeChild(){};safeFunction(Element.prototype.removeChild)

function HTMLElement(){
    Element.call(this)
};safeFunction(HTMLElement)
HTMLElement.prototype = Object.create(Element.prototype)
HTMLElement.prototype.constructor = HTMLElement;

globalThis.window.HTMLElement = HTMLElement;

function HTMLHtmlElement(){}
HTMLHtmlElement.prototype.getAttribute = function () {
    return null;
}
function HTMLAllCollection (){
    this.length = 1181;
};safeFunction(HTMLAllCollection)

function HTMLBodyElement (){
    HTMLElement.call(this)
};safeFunction(HTMLBodyElement)
HTMLBodyElement.prototype = Object.create(HTMLElement.prototype)
HTMLBodyElement.prototype.constructor = HTMLBodyElement;

function Document(){}
Document.prototype = Object.create(Node.prototype);
Document.prototype.getElementsByTagName = function (tagName) {
    if (tagName.toLowerCase() === "*") {
        return [
    {"tagName": "html"},
    {"tagName": "head"},
    {"tagName": "script"},
    {"tagName": "meta"},
    {"tagName": "link"},
    {"tagName": "style"},
    {"tagName": "title"},
    {"tagName": "body"},
    {"tagName": "div"},
    {"tagName": "svg"},
    {"tagName": "defs"},
    {"tagName": "clippath"},
    {"tagName": "rect"},
    {"tagName": "path"},
    {"tagName": "symbol"},
    {"tagName": "circle"},
    {"tagName": "g"},
    {"tagName": "header"},
    {"tagName": "a"},
    {"tagName": "img"},
    {"tagName": "input"},
    {"tagName": "use"},
    {"tagName": "button"},
    {"tagName": "span"},
    {"tagName": "ul"},
    {"tagName": "li"},
    {"tagName": "picture"},
    {"tagName": "i"},
    {"tagName": "p"},
    {"tagName": "section"},
    {"tagName": "iframe"}
]
    }
}
Document.prototype.all = new HTMLAllCollection();
Document.prototype.body = new HTMLBodyElement();
Document.prototype.cookie = globalThis.window.ck;

function HTMLDocument() {}
HTMLDocument.prototype = Object.create(Document.prototype);

globalThis.document = Object.create(HTMLDocument.prototype);safeFunction(globalThis.document);
globalThis.document.documentElement = Object.create(HTMLHtmlElement.prototype);

globalThis.window.document = globalThis.document;

globalThis.Screen = makeFunction("Screen");
globalThis.screen = new globalThis.Screen();
globalThis.window.screen = globalThis.screen;
globalThis.window.Screen = globalThis.Screen;

globalThis.History = makeFunction("History");
globalThis.history = new globalThis.History();
globalThis.window.history = globalThis.history;
globalThis.window.History = globalThis.History;


globalThis.Navigator = makeFunction("Navigator");
globalThis.Navigator.prototype.appCodeName = "Mozilla";
globalThis.Navigator.prototype.appName = "Netscape";
globalThis.Navigator.prototype.language = "zh-CN";
globalThis.Navigator.prototype.languages = [
    "zh-CN",
    "zh",
    "en"
];
globalThis.Navigator.prototype.platform = "MacIntel";
globalThis.Navigator.prototype.product = "Gecko";
globalThis.Navigator.prototype.productSub = "20030107";
function PermissionStatus(){
    this.state = "denied"
    this.then = function then(){}
};safeFunction(PermissionStatus)
function Permissions(){
}
Permissions.prototype.query = function query() {
    return Promise.resolve(new PermissionStatus())
};safeFunction(Permissions.prototype.query)
globalThis.Navigator.prototype.permissions = new Permissions()
globalThis.Navigator.prototype.userAgent = "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/139.0.0.0 Safari/537.36";
globalThis.Navigator.prototype.vendor = "Google Inc.";
globalThis.Navigator.prototype.webdriver = false;
globalThis.navigator = new globalThis.Navigator();
globalThis.window.navigator = globalThis.navigator;
globalThis.window.Navigator = globalThis.Navigator;


function Storage(){}
globalThis.sessionStorage = new Storage();
globalThis.window.sessionStorage = globalThis.sessionStorage;

globalThis.localStorage = new Storage();
globalThis.window.localStorage = globalThis.localStorage;
globalThis.window.Storage = Storage;


function Location(){}
Location.prototype = {
    "ancestorOrigins": {},
    "href": "https://bf5b000000001001945f?xsec_token=AB3TbsCqzVXoWzLIZU5EZiXQBkisr5haqXi5iXIV2NtO0=&xsec_source=pc_note",
    "origin": "https:shu.com",
    "protocol": "https:",
    "host": "www..com",
    "hostname": "www.xiaohongshu.com",
    "port": "",
    "pathname": "/user/00000001001945f",
    "search": "?xsec_token=AB3TbsCqzVXoWzLIZU5EZiXQBkisr5haqXi5iXIV2NtO0=&xsec_source=pc_note",
    "hash": ""
}
globalThis.location = new Location();
globalThis.window.location = globalThis.location;
globalThis.window.Location = Location;